import React, { useState } from "react";
import "./navbar.css";
import { IoMenuOutline } from "react-icons/io5";
import { Button, Tabs } from "@mui/material";
import { motion } from "framer-motion";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Sidebar from "./Sidebar";
import { resumeLink } from "../../config/ResumeLink";


const tabStyle = {
  default_tab: {
    color: "#ffffff",
    fontSize: 15,
    fontWeightLight: 800,
  },
  active_tab: {
    color: "grey700",
    width: "33.3%",
    backgroundColor: "#FFFFFF",
    fontSize: 15,
  },
};

const Navbar = ({homeRef,aboutRef,skillRef,projectRef,contactRef}) => {
  const [isDrawer,setIsDrawer]=useState(false)
  const [value, setValue] = React.useState("one");
  const handleChange = (event, newValue) => {
    setValue(newValue);
    console.log("handle change")
  };

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: -180 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          ease: "easeInOut",
          duration: 5,
          delay: 0.6,
        }}
       
        className="text-white px-10 flex justify-between items-center py-4 bg-black bg-opacity-50 z-50 fixed w-[100vw] lg:w-full"
      >
        <div className="flex lg:space-x-6 items-center">
          <IoMenuOutline
            onClick={()=>setIsDrawer(true)}
            className="text-white text-3xl lg:hidden pr-2 " />
          <span className="logo text-md lg:text-2xl mx-4">Ashok Zarmariya</span>
          <div className="absolute">
            <Sidebar isDrawer={isDrawer}
              handleClose={() => setIsDrawer(false)}
              homeRef={homeRef}
              aboutRef={aboutRef}
              skillRef={skillRef}
              projectRef={projectRef}
              contactRef={contactRef}
            />
          </div>

          <div className="hidden lg:block">
            <Box sx={{ width: "100%" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                textColor="secondary"
                aria-label="secondary tabs example"
              >
                <Tab
                  style={tabStyle.default_tab}
                  onClick={() => {
                    homeRef.current.scrollIntoView({"behavior":"smooth"})
                  }}
                  value="one" label="home" />
                <Tab style={tabStyle.default_tab}
                 
                  onClick={() => {
                    aboutRef.current.scrollIntoView({"behavior":"smooth"})
                  }}
                  value="two" label="about" />
                <Tab
                  onClick={() => {
                    skillRef.current.scrollIntoView({"behavior":"smooth"})
                  }}
                  style={tabStyle.default_tab} value="three" label="skill" />
                <Tab
                  onClick={() => {
                    projectRef.current.scrollIntoView({"behavior":"smooth"})
                  }}
                  style={tabStyle.default_tab} value="four" label="Projects" />
                <Tab
                  onClick={() => {
                    contactRef.current.scrollIntoView({"behavior":"smooth"})
                  }}
                  style={tabStyle.default_tab} value="five" label="Contact" />
              </Tabs>
            </Box>
          </div>
        </div>

        <div>
          <Button size={`${window.screen.width>700}?small :large`} className="border-2 border-blue-500 " variant="outlined">
            <a href={resumeLink} target="-blank">
              Resume
            </a>
          </Button>
        </div>
      </motion.div>
     
    </>
  );
};

export default Navbar;
